// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2cb2dcd3","453":"7630e0c2"}[chunkId] + ".chunk.js";
};